module.exports = __webpack_public_path__ + "img/guaranteeSate_13.472f1331.png";